import { Link } from "react-router-dom";
import { Heart, Mail, Shield, FileText, Cookie } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background/20 backdrop-blur-sm border-t border-white/10 mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img
                src="/lovable-uploads/5e002d38-22aa-49af-85ae-34109191ea66.png"
                alt="AstroPet Logo"
                className="w-8 h-8"
              />
              <h3 className="text-lg font-bold gradient-text">AstroPet</h3>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Il social network del futuro dedicato ai tuoi amici a quattro zampe. Connetti, condividi e esplora
              l'universo pet.
            </p>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-white">Informazioni Legali</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-white/70 hover:text-primary transition-colors flex items-center gap-2"
                >
                  <FileText className="w-4 h-4" />
                  Termini di Servizio
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-white/70 hover:text-primary transition-colors flex items-center gap-2"
                >
                  <Shield className="w-4 h-4" />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie-policy"
                  className="text-white/70 hover:text-primary transition-colors flex items-center gap-2"
                >
                  <Cookie className="w-4 h-4" />
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h4 className="font-semibold text-white">Supporto</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="mailto:support@astropet.com"
                  className="text-white/70 hover:text-primary transition-colors flex items-center gap-2"
                >
                  <Mail className="w-4 h-4" />
                  support@astropet.it
                </a>
              </li>
              <li>
                <a
                  href="mailto:privacy@astropet.com"
                  className="text-white/70 hover:text-primary transition-colors flex items-center gap-2"
                >
                  <Shield className="w-4 h-4" />
                  privacy@astropet.it
                </a>
              </li>
            </ul>
          </div>

          {/* Company Info */}
          <div className="space-y-4">
            <h4 className="font-semibold text-white">AstroPet S.r.l.</h4>
            <div className="text-sm text-white/70 space-y-1"></div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-white/60">© {currentYear} AstroPet S.r.l. Tutti i diritti riservati.</div>

            <div className="flex items-center space-x-4 text-sm text-white/60">
              <span>Fatto con</span>
              <Heart className="w-4 h-4 text-red-400 fill-current" />
              <span>per gli amanti degli animali</span>
            </div>
          </div>

          {/* GDPR Compliance Note */}
          <div className="mt-4 text-xs text-white/50 text-center">
            Questo sito è conforme al GDPR (Regolamento UE 2016/679) e alle normative italiane sulla privacy. I dati
            personali sono trattati nel rispetto della normativa vigente.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
